<div class="w-full h-full overflow-hidden overflow-y-auto">
  <p-table [value]="tableDataCustomer"
           [scrollable]="true">
    <ng-template pTemplate="body" let-data>
      <tr>
        <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis pl-0"
            [ngClass]="data?.titleStyleClass ? data.titleStyleClass : null"
            [colSpan]="data?.titleColspan ? 2 : 1"
            [width]="titleColumnWidth">
          {{ data?.i18nTitleKey ? i18n.i18nLng()[data.i18nTitleKey] : data?.title }}
        </td>
        <!-- TODO implement needed value-types -->
        @if (!data?.titleColspan) {
          @switch (data?.valueType) {
            @case ('MULTILINE') {
              <td class="overflow-hidden text-overflow-ellipsis line-height-3"
                  [style]="{'white-space': 'pre-line', 'min-width': '160px'}"
                  [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                  [width]="valueColumnWidth">
                {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
              </td>
            }
            @default {
              <td class="overflow-hidden text-overflow-ellipsis"
                  [style]="{'min-width': '160px'}"
                  [ngStyle]="{'white-space': (layoutService.isMobile() ? 'nowrap !important': 'normal !important')}"
                  [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                  [width]="valueColumnWidth">
                {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
              </td>
            }
          }
        }
      </tr>
    </ng-template>
  </p-table>
</div>
